<template>
  <div class="loginSession background">
    <div class="imageDiv">
      <img class="logoImg" src="~common/image/qy_logo.png">
    </div>
    <div class="logoTitle">旗鱼算账宝</div>
    <div class="logoLine">
      <hr>
      <span>登录</span>
      <hr>
    </div>
    <form class="loginForm" action="">
      <div class="loginUserName">
        <div class="userNameIcon">
          <img src="~common/image/userIcon.png">
        </div>
        <input class="userName" type="text" placeholder="请输入手机号码" maxlength="11" v-model="mobile">
        <div class="errorIcon" v-show="mobile !==''"  @click.prevent="deleteFn(1)">
          <img src="~common/image/errorDelete.png">
        </div>
      </div>
      <div class="phontTip">
        <p>注：请填写商家负责人手机号，或有权限登录算账宝的手机号码</p>
      </div>
      <div class="loginPassWord" v-show="true">
        <div class="passwordDiv">
          <div class="passWordIcon">
            <img src="~common/image/passWordIcon.png">
          </div>
          <input class="passWord" type="text" v-model="smsCode" placeholder="请输入验证码">
          <div class="errorIcon" v-show="smsCode !==''"  @click.prevent="deleteFn(2)">
            <img src="~common/image/errorDelete.png">
          </div>
        </div>
        <button class="verifiCode" @click.prevent="getVerifiCode()" :disabled="!countShow" :class="{'getCode':countShow,'afterCode':!countShow}">
            <span v-show="countShow">获取验证码</span>
            <span v-show="!countShow" class="count">{{count}}s</span>
        </button>
      </div>
      <div class="loginHint">
         <div class="loginError" v-show="errorMsgDIv"><img src="~common/image/warning.png"><span>{{errorMsg}}</span></div>  
      </div>
      <div class="loginBtn">
        <button class="login" @click.prevent="getLoginDate" :disabled="ifDisable" :class="{'login':!ifDisable,'noLogin':ifDisable}">登录</button>
      </div>
    </form>
    <div class="loginStyle">
      <div class="selectArea" @click="loginSelect">
        <span>普通方式登录</span>
      </div> 
    </div>
  </div>
</template>
<script>
  import 'common/js/rem'
  import Common from 'common/js/common'
  import { MessageBox } from 'mint-ui'
  export default {
    data() {
      return {
        countShow: true,
        count: '',
        errorMsg: '',
        errorMsgDIv: false,
        mobile: '',
        smsCode: '',
        ifDisable: true,
        timer: null
      }
    },
    methods: {
      getLoginDate() {
        // this.$router.push({ path: '/shopSelect' })
        const _this = this
        console.log(222222222, Common.url_user, process.env);
        this.$http.get(Common.url_user + '/managerH5LoginService', {
          params: {
            openId: Common.localGet('openId'),
            phone: this.mobile,
            smsCode: this.smsCode
          }
        })
        .then(function(response) {
          console.log(response.data.code)
          if (response.data.code === 0) {
            console.log('长度' + response.data.data.length + response.data.data[0].userId + response.data.data[0].merchangId)
            if (response.data.data.length === 1) { // 只有一家商户时直接跳到首页而不用跳到商户选择页
              _this.oneMerchant(response.data.data[0].userId, response.data.data[0].merchangId)
            }
            _this.common.localSet('merchantIdList', response.data.data)
            _this.$router.push({ path: '/shopSelect' })
          } else {
            _this.errorMsgDIv = true
            _this.errorMsg = response.data.msg
          }
        })
        .catch(function(error) {
          // _this.$toast.log('错误的请求' + error)
          _this.$toast(error)
        })
      },
      oneMerchant(userId, merchangId) {
        const _this = this
        this.$http.get(Common.url_user + '/managerH5BindMerchant', {
          params: {
            openId: Common.localGet('openId'),
            userId: userId,
            merchantId: merchangId
          }
        })
        .then(function(response) {
          console.log(JSON.stringify(response))
          if (response.data.code === 0) {
            _this.common.localSet('loginInfo', response.data.data)
            _this.$router.push({ path: '/dataDisplay' })
          } else if (response.data.code === 300008) {  // 取消权限或被迫下线
            MessageBox.confirm('', {
              message: response.data.msg,
              title: '提示',
              confirmButtonText: '确定',
              showCancelButton: false
            }).then(action => {
              if (action === 'confirm') {
                _this.$router.push({ path: '/login' })
              }
            })
          } else {
            MessageBox.confirm('', {
              message: response.data.msg,
              title: '提示',
              confirmButtonText: '确定',
              showCancelButton: false
            }).then(action => {
              if (action === 'confirm') {
                console.log(response.data.msg)
              }
            })
          }
        })
        .catch(function(error) {
          // _this.$toast.log('错误的请求' + error)
          _this.$toast(error)
        })
      },
      // 获取验证码
      getVerifiCode() {
        var _this = this
        // 手机号码格式验证
        var phone = /^1[3|4|5|7|8]\d{9}$/
        if (!phone.test(this.mobile) || this.mobile === '') {
          this.errorMsgDIv = true
          this.errorMsg = '手机号码格式有误'
        } else {
          // 短信验证码接口
          this.$http.get(Common.url_user + '/sendSmsCode', {
            params: {
              phone: this.mobile
            }
          })
        .then(function(response) {
          console.log(JSON.stringify(response))
          if (response.data.code === 0) {
            _this.disableStyle = true
            _this.errorMsgDIv = false
            _this.getVerifiTime()
          } else {
            _this.errorMsgDIv = true
            _this.errorMsg = response.data.msg
          }
        })
        .catch(function(error) {
          console.log('错误的请求' + error)
        })
        }
      },
      // 验证码倒计时
      getVerifiTime() {
        const TIME_COUNT = 60
        if (!this.timer) {
          this.count = TIME_COUNT
          this.countShow = false
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
            } else {
              this.countShow = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
      },
      deleteFn(deleteStyle) {
        if (deleteStyle === 1) {
          this.mobile = ''
        } else if (deleteStyle === 2) {
          this.smsCode = ''
        }
        this.errorMsgDIv = false
      },
      loginSelect() {
        this.$router.push({ path: '/loginTwo' })
      }
    },
    watch: {
      mobile(val, oldVal) { // 新值和旧值
        if (val !== oldVal) {
          this.errorMsgDIv = false
        }
        if (this.mobile !== '' && this.smsCode !== '') { // 有一个为空，登录置灰
          this.ifDisable = false
        } else {
          this.ifDisable = true
        }
      },
      smsCode(val, oldVal) { // 新值和旧值
        if (val !== oldVal) {
          this.errorMsgDIv = false
        }
        if (this.mobile !== '' && this.smsCode !== '') { // 有一个为空，登录置灰
          this.ifDisable = false
        } else {
          this.ifDisable = true
        }
      }
    }
  }
</script>


<style scoped>

  .loginSession {
    width: 100%;
    height: 100%;
    background:url('~common/image/loginBackground.jpg') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    text-align: center;
    overflow: auto;
  }
  
  .imageDiv {
    padding-top: 0.54rem;
    text-align: center;
    font-size: 0;
  }
  
  .logoImg {
    width: 1.5rem;
    height: 1.5rem;
  }
  
  .loginForm{
     margin: 0 auto;
     width: 6rem;
     height: auto; 
  }
  .loginUserName{
    position: relative;
  }
  .loginStyle{
    margin-top: 0.9rem;
    color: #ffffff;
    font-size: 0.28rem;
  }
  .logoLine{
    width: 6rem;
    margin: 0.9rem auto 0 auto;
    font-size: 0.32rem;
    color: #ffffff;
    display:flex;
    display: -webkit-flex; 
    align-items:center;
    justify-content: center;
  }
  .logoLine hr{
    display: inline-block;
    width: 2.4rem;
    height: 1px;
    border: none;
    border-top: 1px solid #ffffff;
  }
  .logoLine span{
    width: 1.2rem;
  }
  .phontTip{
    font-size: 0.24rem;
    height: 0.8rem;
    line-height: 0.4rem;
    color: #ffffff;
    padding: 0 0.1rem;
    margin: 0 0 0.3rem 0;
    text-align: left;
  }
  .marginStyle{
    margin: 0.8rem 0 0.2rem 0!important;
  }
  .selectArea{
    display: inline-block;
    width: 2.6rem;
    height: 0.8rem;
  }
  .selectArea span{
    display: inline-block;
    border-bottom: 1px solid #ffd200;
    color:#ffd200;
  } 
  .userNameIcon,
  .passWordIcon {
    position: absolute;
    left: 0.3rem;
    top: 0.22rem;
  }
  
  .userNameIcon img,
  .passWordIcon img {
    width: 0.42rem;
    height: 0.42rem;
    font-size: 0;
  }
  .errorIcon{
    position: absolute;
    height: 0.9rem;
    width: 0.6rem;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .errorIcon img{
    width: 0.2rem;
    height: 0.2rem;
    font-size: 0;
  }
  .passwordDiv{
    position: relative;
    display: inline-block;
  }
  .logoTitle {
    margin-top: 0.26rem;
    font-size: 0.42rem;
    color: #ffffff;
    font-weight: bold;
  }
  .logoLine{
    margin-top: 0.9rem;
    font-size: 0.32rem;
    color: #ffffff;
  }
  .loginHint {
    height: 0.24rem;
    font-size: 0.24rem;
    color: #ffffff;
    text-align: center;
    margin: 1rem 0 0.2rem 0;
  }
  
  .loginUserName {
    margin-top: 0.6rem;
  }
  
  input:focus,button{
    outline: none;
  }
  .userName,
  .passWord {
    width: 6rem;
    height: 0.9rem;
    font-size: 0.28rem;
    color: #000;
    background-color: #F1F2F3;
    border: 1px solid #F74d47;
    padding-left: 1.1rem;
    padding-right: .1rem;
    border-radius: 0.1rem;
    box-sizing: border-box;
  }
  
  .passWord {
    width: 3.5rem;
  }
  
  .verifiCode,.getCode {
    width: 2.4rem;
    height: 0.9rem;
    color: #f74d47;
    font-size: .2rem;
    background-color: #ffffff;
    border-radius: .1rem;
    border: 0;
    vertical-align: top
  }
  .afterCode{
    background-color: #ccc;
  }
  .loginCon{
    margin-top: 1.7rem;
    position: relative;
  }
  .loginError,.userError,.passwordError {
    /* position: absolute; */
    text-align: center;
    font-size: 0.25rem;
    width: 100%;
    color: #ffffff;
    bottom: 0.3rem;
  }
  .loginError{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  
  .loginError img,.userError img,.passwordError img {
    height: .26rem;
    vertical-align: middle;
    padding-right: .06rem;
  }
  .login {
    width: 6rem;
    height: 0.9rem;
    color: #f74d47;
    font-size: 0.36rem;
    background-color: #ffffff;
    border: 0;
    border-radius: .1rem;
  }
  .noLogin {
    background-color: #CCCCCC;
     color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue